import { HeartHandshake } from "lucide-react";
import { CtaButton } from "@/components/CtaButton";

const GUIDE = { label: "Schedule a Goddess Guide Call", url: "https://live.vcita.com/site/GoddessLaMeel", kind: "guide" };

export const GuideCard = () => (
  <section className="fea-section fea-section-highlight no-print" data-testid="guide-card">
    <div className="flex items-start gap-4">
      <span className="fea-icon-badge"><HeartHandshake className="h-5 w-5" /></span>
      <div>
        <p className="fea-overline">Personal guidance</p>
        <h2 className="font-serif text-2xl sm:text-3xl font-semibold text-[#800534] mt-2">Would you like personal guidance?</h2>
      </div>
    </div>
    <div className="space-y-4 mt-5">
      <p className="fea-body">Your Feminine Energy Assessment reveals where your energy may need attention and which educational experiences align with your next stage of expansion.</p>
      <p className="fea-body">If you'd like help exploring your results, recommended courses, or coaching opportunities, schedule a Goddess Guide conversation.</p>
    </div>
    <div className="mt-6"><CtaButton cta={GUIDE} testId="guide-card-button" /></div>
  </section>
);
